<template>
<div class="tabs-transfer">
    <div class="tab-transfer">{{$t('language.popup.chooseAction')}}</div>
    <cloud-select ref="cloudSelect" :widthVal="400" @changeOption="onChangeOption" :selectOption="selectOption" :placeholder="placeholderValue" style="margin:0px !important;/*no*/"></cloud-select>
    <div class="tab-check">
        <div v-for="(checkItem,index) in checkItems" :key="index" class="check-item" v-show="!($parent.$parent.$parent.item&&$parent.$parent.$parent.item.branchType==='share'&&(index==0||index==1))">
            <div class="icon-util tab-float" @click="checkedItem(index)" :class="[checkArr.includes(index)?'check-small':'nocheck-small-blue',index==3?'tab-float':'',checkItemsIsDisable(index)?'check-none':'']"></div>
            <font @click="checkedItem(index)">{{checkItem.name}}</font>
            <div class="icon-util question-mark question-mark-position" v-if="index==2||index==3||index==4" @mouseover="promptShow=true" @mouseout="promptShow=false">
                <div :class="$i18n.locale=='france'?'prompt-right':'prompt'" v-if="index==2">{{$t('language.popup.optionsPrompt')}}</div>
                <div :class="$i18n.locale=='france'?'prompt-right':'prompt-team'" v-if="index==3">{{$t('language.teamTransfer.optionActivated')}}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import cloudSelect from "@/components/common/select/cloud_select";
export default {
    components: {
        "cloud-select": cloudSelect
    },
    data: function () {
        return {
            selectOption: [{
                    name: this.$t('language.popup.skipFile')

                },
                {
                    name: this.$t('language.popup.sourceNewer')

                },
                {
                    name: this.$t('language.popup.diffSize')

                },
                {
                    name: this.$t('language.popup.sourceAll')

                },
                {
                    name: this.$t('language.popup.overWrite')
                },
                {
                    name: this.$t('language.popup.rename')
                }
            ],
            placeholderValue: this.$t('language.popup.skipFile'),
            checkItems: [{
                    name: this.$t('language.popup.deleteAllSource')
                },
                {
                    name: this.$t('language.popup.keepFileDate')
                },
                {
                    name: this.$t('language.popup.automaRename')
                },
                 {
                    name: this.$t('language.teamTransfer.allTransferred')
                },
            ],
            oldSelectValue: this.$t('language.popup.skipFile'),
            oldCheckArr: [2,3],
            checkArr: [2,3],
            promptShow: false
        };
    },
    methods: {
        //选项是否不可编辑
        checkItemsIsDisable(index){
            if(this.$parent.$parent.$parent.item){
                let item = this.$parent.$parent.$parent.item;
                //如果传输任务目标是iCloudPhotos
                if(item.toItem&&item.toItem.driveType&&item.toItem.driveType=="iCloudPhotos"){
                    if(3==index){
                        return true;
                    }
                }
            }
            return false;
        },
        checkedItem(index) {
            if (this.checkArr.includes(index)) {
                this.checkArr = this.checkArr.filter(function (ele) {
                    return ele != index;
                });
                this.removeIndex(index);
            } else {
                this.checkArr.push(index);
                this.caseIndex(index);
            }
        },
        caseIndex(index) {
            switch (index) {
                case 0:
                    this.$parent.$parent.$parent.options.isRemove = 1;
                    break;
                case 1:
                    this.$parent.$parent.$parent.options.isKeep = 1;
                    break;
                case 2:
                    this.$parent.$parent.$parent.options.isChar = 1;
                    break;
                case 3:
                    this.$parent.$parent.$parent.options.keepRoot = 1;
                    break;
            }
        },
        removeIndex(index) {
            switch (index) {
                case 0:
                    this.$parent.$parent.$parent.options.isRemove = 0;
                    break;
                case 1:
                    this.$parent.$parent.$parent.options.isKeep = 0;
                    break;
                case 2:
                    this.$parent.$parent.$parent.options.isChar = 0;
                    break;
                case 3:
                    this.$parent.$parent.$parent.options.keepRoot = 0;
                    break;
            }
        },
        onChangeOption(newValue) {
            switch (newValue.replace(/^\s+|\s+$/g, "")) {
                case this.$t('language.popup.skipFile').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 2;
                    break;
                case this.$t('language.popup.sourceNewer').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 3;
                    break;
                case this.$t('language.popup.diffSize').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 1;
                    break;
                case this.$t('language.popup.sourceAll').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 5;
                    break;
                case this.$t('language.popup.overWrite').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 4;
                    break;
                case this.$t('language.popup.rename').replace(/^\s+|\s+$/g, ""):
                    this.$parent.$parent.$parent.options.replace = 0;
                    break;
            }
        }
    }
};
</script>

<style>
.tabs-transfer {
    width: 100%;
    height: 100%;
}

.question-mark-position {
    position: relative;
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    vertical-align: middle;
}

.tab-float {
    position: relative;
    top: 2px;
    /*no*/
    margin-right: 5px;
    /*no*/
}

.check-none {
    pointer-events: none;
    opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_transfer.vue